import { AwsRum } from "aws-rum-web";
import type { AwsRumConfig } from "aws-rum-web";

// CloudWatch RUM: the JS errors, the failed HTTP calls and the page load times
// of every session (shared/infra/rum.tf makes the app monitor). It sets no
// cookie, so it records no session ID and no user ID. A build without
// REACT_APP_RUM_APP_MONITOR_ID, which is every build except prod, sends
// nothing.

export const RUM_REGION = "us-east-2";

export type RumEnv = {
  REACT_APP_RUM_APP_MONITOR_ID?: string;
  REACT_APP_RUM_IDENTITY_POOL_ID?: string;
  REACT_APP_RUM_GUEST_ROLE_ARN?: string;
};

export const rumConfig = (env: RumEnv): AwsRumConfig => ({
  sessionSampleRate: 1,
  ...(env.REACT_APP_RUM_IDENTITY_POOL_ID
    ? { identityPoolId: env.REACT_APP_RUM_IDENTITY_POOL_ID }
    : {}),
  ...(env.REACT_APP_RUM_GUEST_ROLE_ARN
    ? { guestRoleArn: env.REACT_APP_RUM_GUEST_ROLE_ARN }
    : {}),
  endpoint: `https://dataplane.rum.${RUM_REGION}.amazonaws.com`,
  telemetries: ["errors", "http", "performance"],
  allowCookies: false,
  enableXRay: false,
});

// The build inlines each process.env.REACT_APP_* that it reads by name.
const BUILD_ENV: RumEnv = {
  REACT_APP_RUM_APP_MONITOR_ID: process.env.REACT_APP_RUM_APP_MONITOR_ID,
  REACT_APP_RUM_IDENTITY_POOL_ID: process.env.REACT_APP_RUM_IDENTITY_POOL_ID,
  REACT_APP_RUM_GUEST_ROLE_ARN: process.env.REACT_APP_RUM_GUEST_ROLE_ARN,
};

export function startRum(env: RumEnv = BUILD_ENV): AwsRum | undefined {
  if (!env.REACT_APP_RUM_APP_MONITOR_ID) return undefined;
  try {
    return new AwsRum(
      env.REACT_APP_RUM_APP_MONITOR_ID,
      "1.0.0",
      RUM_REGION,
      rumConfig(env),
    );
  } catch {
    // A monitoring client must never stop the app from starting.
    return undefined;
  }
}
